import { useMemo, useRef } from 'react'
import { Chart as ChartJS, ChartOptions } from 'chart.js'
import styles from 'components/charts/Charts.module.scss'
import { Bar } from 'react-chartjs-2'
import { getBillshockChartOptions } from 'components/charts/billing-cycle/current/chartjs.config'
import { BillingCycleChartProps } from '../types'

const CurrentBillingCycleChartMobile = ({ chartData, minMaxData, labels, setHoverDataPointIndex }: BillingCycleChartProps) => {
  // Reference
  const chartRef = useRef<ChartJS<'bar', (number | null)[]>>(null)

  // Options
  const options = useMemo<ChartOptions<'bar'>>(
    () =>
      getBillshockChartOptions({
        labels,
        minMax: minMaxData,
        isMobile: true,
        handleHoverDataPoint: setHoverDataPointIndex
      }),
    [labels, minMaxData, setHoverDataPointIndex]
  )

  return (
    <div className={styles['chart-wrapper']}>
      <Bar options={options} data={chartData} className={styles.chart} ref={chartRef} />
    </div>
  )
}

export default CurrentBillingCycleChartMobile
